import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type EmailTemplateQueryVariables = Types.Exact<{
  getEmailTemplateInput: Types.GetEmailTemplateInput
}>

export type EmailTemplateQuery = {
  __typename?: 'Query'
  emailTemplate: Array<{
    __typename?: 'EmailTemplate'
    categoryLawyer?: string | null
    name: string
    content: string
    id: number
  }>
}

export const EmailTemplateDocument = gql`
  query EmailTemplate($getEmailTemplateInput: GetEmailTemplateInput!) {
    emailTemplate(getEmailTemplateInput: $getEmailTemplateInput) {
      categoryLawyer
      name
      content
      id
    }
  }
`
export function useEmailTemplateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(
    EmailTemplateDocument,
    options
  )
}
export function useEmailTemplateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmailTemplateQuery,
    EmailTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(
    EmailTemplateDocument,
    options
  )
}
export type EmailTemplateQueryHookResult = ReturnType<typeof useEmailTemplateQuery>
export type EmailTemplateLazyQueryHookResult = ReturnType<typeof useEmailTemplateLazyQuery>
export type EmailTemplateQueryResult = ApolloReactCommon.QueryResult<
  EmailTemplateQuery,
  EmailTemplateQueryVariables
>
export function refetchEmailTemplateQuery(variables?: EmailTemplateQueryVariables) {
  return { query: EmailTemplateDocument, variables: variables }
}
